{
  "generatedBy": "tools/lastage/lastage_yard.py from tools/lastage/sources/woodcut_readings_yard.json",
  "pictureScale": {
    "metresPerPx": 0.12885,
    "source": "tools/quayGoods/sources/picture_scale.json"
  },
  "items": [
    {
      "id": "y01",
      "kind": "boxStack",
      "at": [
        650.108,
        140.987
      ],
      "yaw": 2.591,
      "length": 2.933,
      "width": 1.766,
      "height": 2.963,
      "shift": {
        "from": [
          651.013,
          143.352
        ],
        "metres": 2.533
      },
      "sourceRefs": [
        "woodcut-1544"
      ]
    },
    {
      "id": "y02",
      "kind": "boxStack",
      "at": [
        619.653,
        134.439
      ],
      "yaw": 2.254,
      "length": 2.373,
      "width": 0.863,
      "height": 2.19,
      "shift": {
        "from": [
          615.301,
          135.773
        ],
        "metres": 4.552
      },
      "sourceRefs": [
        "woodcut-1544"
      ]
    },
    {
      "id": "y03",
      "kind": "boxStack",
      "at": [
        623.282,
        142.881
      ],
      "yaw": 2.392,
      "length": 4.454,
      "width": 0.747,
      "height": 1.933,
      "shift": {
        "from": [
          620.232,
          143.816
        ],
        "metres": 3.19
      },
      "sourceRefs": [
        "woodcut-1544"
      ]
    },
    {
      "id": "y04",
      "kind": "boxStack",
      "at": [
        621.864,
        141.036
      ],
      "yaw": 2.468,
      "length": 2.782,
      "width": 0.766,
      "height": 1.16,
      "shift": {
        "from": [
          607.2,
          146.996
        ],
        "metres": 15.829
      },
      "sourceRefs": [
        "woodcut-1544"
      ]
    },
    {
      "id": "y05",
      "kind": "plankPile",
      "at": [
        631.726,
        157.981
      ],
      "yaw": 2.281,
      "length": 10.283,
      "width": 2.747,
      "height": 0.387,
      "shift": {
        "from": [
          627.182,
          159.357
        ],
        "metres": 4.748
      },
      "sourceRefs": [
        "woodcut-1544"
      ]
    },
    {
      "id": "y06",
      "kind": "plankPile",
      "at": [
        650.671,
        210.671
      ],
      "yaw": 2.425,
      "length": 7.782,
      "width": 3.208,
      "height": 0.387,
      "sourceRefs": [
        "woodcut-1544"
      ]
    },
    {
      "id": "y07",
      "kind": "plankPile",
      "at": [
        640.705,
        200.883
      ],
      "yaw": 1.304,
      "length": 2.736,
      "width": 2.676,
      "height": 0.387,
      "shift": {
        "from": [
          628.559,
          204.607
        ],
        "metres": 12.704
      },
      "sourceRefs": [
        "woodcut-1544"
      ]
    },
    {
      "id": "y08",
      "kind": "plankPile",
      "at": [
        660.51,
        264.231
      ],
      "yaw": 2.429,
      "length": 3.723,
      "width": 2.633,
      "height": 0.515,
      "shift": {
        "from": [
          649.068,
          267.739
        ],
        "metres": 11.968
      },
      "sourceRefs": [
        "woodcut-1544"
      ]
    },
    {
      "id": "y09",
      "kind": "plankPile",
      "at": [
        666.277,
        267.363
      ],
      "yaw": 2.308,
      "length": 9.45,
      "width": 2.663,
      "height": 0.387,
      "sourceRefs": [
        "woodcut-1544"
      ]
    },
    {
      "id": "y10",
      "kind": "plankPile",
      "at": [
        670.309,
        276.115
      ],
      "yaw": 2.272,
      "length": 7.72,
      "width": 2.945,
      "height": 0.387,
      "sourceRefs": [
        "woodcut-1544"
      ]
    },
    {
      "id": "y11",
      "kind": "boxStack",
      "at": [
        685.898,
        291.309
      ],
      "yaw": 2.338,
      "length": 3.186,
      "width": 1.73,
      "height": 2.835,
      "sourceRefs": [
        "woodcut-1544"
      ]
    },
    {
      "id": "y12",
      "kind": "logStack",
      "at": [
        653.858,
        239.144
      ],
      "yaw": 2.143,
      "diameter": 0.515,
      "tiers": [
        {
          "count": 7,
          "length": 5.467
        },
        {
          "count": 5,
          "length": 4.296
        },
        {
          "count": 4,
          "length": 3.645
        }
      ],
      "shift": {
        "from": [
          642.069,
          242.758
        ],
        "metres": 12.331
      },
      "sourceRefs": [
        "woodcut-1544"
      ]
    },
    {
      "id": "y13",
      "kind": "beamHeap",
      "at": [
        638.877,
        161.859
      ],
      "section": 0.387,
      "beams": [
        {
          "offset": [
            -3.286,
            1.856
          ],
          "yaw": 1.856,
          "length": 3.942,
          "base": 0.0
        },
        {
          "offset": [
            -0.237,
            -1.718
          ],
          "yaw": 2.549,
          "length": 4.148,
          "base": 0.0
        },
        {
          "offset": [
            0.842,
            -0.637
          ],
          "yaw": 2.471,
          "length": 4.858,
          "base": 0.0
        },
        {
          "offset": [
            1.251,
            -0.459
          ],
          "yaw": 2.861,
          "length": 2.939,
          "base": 0.387
        },
        {
          "offset": [
            1.43,
            0.958
          ],
          "yaw": 2.048,
          "length": 3.17,
          "base": 0.773
        }
      ],
      "sourceRefs": [
        "woodcut-1544"
      ]
    },
    {
      "id": "y14",
      "kind": "beamHeap",
      "at": [
        658.179,
        241.953
      ],
      "section": 0.387,
      "beams": [
        {
          "offset": [
            1.417,
            -2.573
          ],
          "yaw": 2.669,
          "length": 4.468,
          "base": 0.0
        },
        {
          "offset": [
            -0.525,
            -0.357
          ],
          "yaw": 2.281,
          "length": 6.793,
          "base": 0.387
        },
        {
          "offset": [
            -0.484,
            1.191
          ],
          "yaw": 2.196,
          "length": 5.687,
          "base": 0.0
        },
        {
          "offset": [
            0.998,
            0.841
          ],
          "yaw": 2.356,
          "length": 5.12,
          "base": 0.0
        },
        {
          "offset": [
            0.886,
            0.645
          ],
          "yaw": -2.587,
          "length": 3.059,
          "base": 0.773
        },
        {
          "offset": [
            -2.292,
            0.253
          ],
          "yaw": 2.665,
          "length": 2.57,
          "base": 0.0
        }
      ],
      "sourceRefs": [
        "woodcut-1544"
      ]
    },
    {
      "id": "y15",
      "kind": "heap",
      "at": [
        645.217,
        199.67
      ],
      "diameter": 5.669,
      "height": 3.865,
      "shift": {
        "from": [
          643.254,
          200.207
        ],
        "metres": 2.035
      },
      "sourceRefs": [
        "woodcut-1544"
      ]
    },
    {
      "id": "y16",
      "kind": "kettle",
      "at": [
        663.93,
        87.302
      ],
      "diameter": 1.675,
      "potHeight": 1.546,
      "legHeight": 0.515,
      "shift": {
        "from": [
          672.462,
          93.062
        ],
        "metres": 10.295
      },
      "sourceRefs": [
        "woodcut-1544"
      ]
    }
  ]
}
